import * as React from 'react'

import { overrideStyledVariantValue } from '~/utilities/override-styled-variant-value/overrideStyledVariantValue'

import { Icon } from '../icon/Icon'
import { AvatarRootContext } from './AvatarContext'

const toIconSize = {
  xs: 'sm',
  sm: 'sm',
  md: 'md',
  lg: 'md',
  xl: 'lg',
  xxl: 'lg'
}

export const AvatarIcon = ({ is }: { is: typeof Icon }) => {
  const rootContext = React.useContext(AvatarRootContext)
  const { size } = rootContext
  const iconSize = React.useMemo(
    () => overrideStyledVariantValue(size, (s) => toIconSize[s]),
    [size]
  )

  return <Icon size={iconSize} is={is} />
}
